/* ── Jinshu Theme JS ── */

(function () {
    'use strict';

    /* ── Fade-up IntersectionObserver ── */
    var fadeEls = document.querySelectorAll('.fade-up');
    if ('IntersectionObserver' in window && fadeEls.length) {
        var obs = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) {
                if (e.isIntersecting) {
                    e.target.classList.add('vis');
                    obs.unobserve(e.target);
                }
            });
        }, { threshold: 0.15 });
        fadeEls.forEach(function (el) { obs.observe(el); });
    } else {
        fadeEls.forEach(function (el) { el.classList.add('vis'); });
    }

    /* ── Nav scroll handler (rAF-batched to avoid forced reflow) ── */
    var nav = document.getElementById('mainNav');
    if (nav) {
        var ticking = false;
        var onScroll = function () {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(function () {
                    if (window.scrollY > 60) {
                        nav.classList.add('scrolled');
                    } else {
                        nav.classList.remove('scrolled');
                    }
                    ticking = false;
                });
            }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        requestAnimationFrame(function () {
            if (window.scrollY > 60) { nav.classList.add('scrolled'); }
        });
    }

    /* ── Mobile burger menu ── */
    var burger = document.getElementById('burger');
    var navLinks = document.getElementById('navLinks');
    if (burger && navLinks) {
        burger.addEventListener('click', function () {
            burger.classList.toggle('open');
            navLinks.classList.toggle('open');
        });
        navLinks.querySelectorAll('a').forEach(function (a) {
            a.addEventListener('click', function () {
                burger.classList.remove('open');
                navLinks.classList.remove('open');
            });
        });
    }

})();

/* ── COA / Lab Results page functions ── */

function toggleCoa(el) {
    var card = el.closest('.coa-card');
    if (card) card.classList.toggle('open');
}

function searchBatch() {
    var input = document.getElementById('batchInput');
    if (!input) return;
    var q = input.value.trim().toLowerCase();
    var cards = document.querySelectorAll('.coa-card');
    var noRes = document.getElementById('noRes');
    var found = false;

    cards.forEach(function (c) {
        var batch = (c.getAttribute('data-batch') || '').toLowerCase();
        if (q && batch.indexOf(q) !== -1) {
            c.style.display = '';
            c.classList.add('open');
            found = true;
        } else if (q) {
            c.style.display = 'none';
        } else {
            c.style.display = '';
            c.classList.remove('open');
            found = true;
        }
    });

    if (noRes) noRes.style.display = (q && !found) ? 'block' : 'none';
}

function filterCoa(product, btn) {
    var cards = document.querySelectorAll('.coa-card');
    var noRes = document.getElementById('noRes');
    if (noRes) noRes.style.display = 'none';

    var input = document.getElementById('batchInput');
    if (input) input.value = '';

    cards.forEach(function (c) {
        if (product === 'all' || c.getAttribute('data-product') === product) {
            c.style.display = '';
        } else {
            c.style.display = 'none';
        }
    });

    document.querySelectorAll('.fbtn').forEach(function (b) { b.classList.remove('on'); });
    if (btn) btn.classList.add('on');
}
